/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdAlliancehistory200Ok
 */
export interface GetCorporationsCorporationIdAlliancehistory200Ok {
    /**
     * alliance_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdAlliancehistory200Ok
     */
    allianceId?: number;
    /**
     * True if the alliance has been closed
     * @type {boolean}
     * @memberof GetCorporationsCorporationIdAlliancehistory200Ok
     */
    isDeleted?: boolean;
    /**
     * An incrementing ID that can be used to canonically establish order of records in cases where dates may be ambiguous
     * @type {number}
     * @memberof GetCorporationsCorporationIdAlliancehistory200Ok
     */
    recordId: number;
    /**
     * start_date string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdAlliancehistory200Ok
     */
    startDate: Date;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdAlliancehistory200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdAlliancehistory200Ok(value: object): value is GetCorporationsCorporationIdAlliancehistory200Ok {
    if (!('recordId' in value) || value['recordId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdAlliancehistory200OkFromJSON(json: any): GetCorporationsCorporationIdAlliancehistory200Ok {
    return GetCorporationsCorporationIdAlliancehistory200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdAlliancehistory200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdAlliancehistory200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'allianceId': json['alliance_id'] == null ? undefined : json['alliance_id'],
        'isDeleted': json['is_deleted'] == null ? undefined : json['is_deleted'],
        'recordId': json['record_id'],
        'startDate': (new Date(json['start_date'])),
    };
}

export function GetCorporationsCorporationIdAlliancehistory200OkToJSON(json: any): GetCorporationsCorporationIdAlliancehistory200Ok {
    return GetCorporationsCorporationIdAlliancehistory200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdAlliancehistory200OkToJSONTyped(value?: GetCorporationsCorporationIdAlliancehistory200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alliance_id': value['allianceId'],
        'is_deleted': value['isDeleted'],
        'record_id': value['recordId'],
        'start_date': ((value['startDate']).toISOString()),
    };
}

